import React from "react";
import "../../../AllComponentCSS.css";

function JS_flatMap() {
  return (
    <div className="tutorial-page">
      <h1>JS flatMap</h1>
      <p>This page will cover the flatMap topic in detail.</p>
    </div>
  );
}

export default JS_flatMap;
